import et99 from "./et99";
import et99Linux from "./et99Linux";

function isLinux() {
  const platform = navigator.platform.toLowerCase();
  const userAgent = navigator.userAgent.toLowerCase();
  return platform.indexOf("linux") > -1 || userAgent.indexOf("linux") > -1;
}

export default isLinux() ? et99Linux : et99;
